import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 11 2ZM8.75 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM2 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
    />
    <path d="M4.5 9.75c.523 0 1.02.123 1.466.344a6.032 6.032 0 0 0-1.113 1.188 1.982 1.982 0 0 0-.353-.032c-1.16 0-2.1 1.007-2.1 2.25v1.75h1.35v1.5H1.7c-.387 0-.7-.336-.7-.75v-2.5c0-2.071 1.567-3.75 3.5-3.75ZM20.3 16.75h-2.05v-1.5h1.35V13.5c0-1.243-.94-2.25-2.1-2.25-.12 0-.238.01-.353.032a6.031 6.031 0 0 0-1.113-1.188c.446-.22.943-.344 1.466-.344 1.933 0 3.5 1.679 3.5 3.75V16c0 .414-.313.75-.7.75Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 14.75A4.75 4.75 0 0 1 9.75 10h2.5A4.75 4.75 0 0 1 17 14.75v3.5a.75.75 0 0 1-.75.75H5.75a.75.75 0 0 1-.75-.75v-3.5Zm4.75-3.25a3.25 3.25 0 0 0-3.25 3.25v2.75h9v-2.75a3.25 3.25 0 0 0-3.25-3.25h-2.5Z"
    />
  </svg>
);
